import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiChip, MiStackedTypography } from "@miplatform/components";
import { getContrastColor } from "@miplatform/utils";
import { ORDERS_DEFAULT_FIELD_WIDTH } from "../../ordersConstants";

interface OrderCardOrderTypeFieldProps {
  orderTemplateName: string;
  orderTemplateAbbreviation: string;
  orderTemplateColor: string;
  orderTemplateShortName?: string;
}

export const OrderCardOrderTypeField = memo(
  ({
    orderTemplateName,
    orderTemplateAbbreviation,
    orderTemplateColor,
    orderTemplateShortName,
  }: OrderCardOrderTypeFieldProps) => {
    const { classes } = useStyles();

    return (
      <MiStackedTypography
        forceTooltip
        title="Order"
        className={classes.fieldMargin}
        tooltipProps={{ title: orderTemplateName }}
        descriptionProps={{
          minWidth: ORDERS_DEFAULT_FIELD_WIDTH,
          maxWidth: ORDERS_DEFAULT_FIELD_WIDTH,
          children: (
            <>
              <MiChip
                className={classes.orderChip}
                label={orderTemplateAbbreviation}
                style={{
                  backgroundColor: orderTemplateColor,
                  color: getContrastColor(orderTemplateColor),
                }}
                size="small"
              />
              {orderTemplateShortName || orderTemplateName}
            </>
          ),
        }}
      />
    );
  }
);

const useStyles = makeStyles()((theme) => ({
  orderChip: {
    borderRadius: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  fieldMargin: {
    marginRight: theme.spacing(2),
  },
}));
